import React from 'react';
import '../../../../styles/Home.css';

const JournalOfWorldTrade = () => {
    return (
      <div className="TopicBorder BGGrey" style={{ marginTop: "4%" }}>
        <a
          href="https://www.scopus.com/sourceid/26842?dgcid=sc_widget_citescore"
          style={{ textDecoration: "none", color: "#505050" }}
        >
          <div
            style={{
              height: 100,
              width: 290,
              fontFamily: "Arial, Verdana, helvetica, sans-serif",
              backgroundColor: "#ffffff",
              display: "inline-block",
            }}
          >
            <div style={{ padding: "0px 16px" }}>
              <div style={{ paddingTop: 3, lineHeight: 1 }}>
                <div style={{ float: "left", fontSize: 28 }}>
                  <span
                    id="citescoreVal"
                    style={{
                      letterSpacing: "-2px",
                      display: "inline-block",
                      paddingTop: 7,
                      lineHeight: ".75",
                    }}
                  >
                    1.0
                  </span>
                </div>
                <div
                  style={{
                    float: "right",
                    fontSize: 14,
                    paddingTop: 3,
                    textAlign: "right",
                  }}
                >
                  <span id="citescoreYearVal" style={{ display: "block" }}>
                    2023
                  </span>
                  CiteScore
                </div>
              </div>
              <div style={{ clear: "both" }} />
              <div style={{ paddingTop: 3 }}>
                <div style={{ height: 4, backgroundColor: "#DCDCDC" }}>
                  <div
                    style={{ height: 4, backgroundColor: "#007398",
                    width: "52%" }}
                    id="percentActBar"
                  >
                    &nbsp;
                  </div>
                </div>
                <div style={{ fontSize: 11 }}>
                  <span id="citescorePerVal">52nd percentile</span>
                </div>
              </div>
              <div style={{ fontSize: 12, textAlign: "right" }}>
                Powered by &nbsp;
                <span>
                  <img
                    alt="Scopus"
                    style={{ width: 50, height: 15 }}
                    src="https://www.scopus.com/static/images/scopusLogoOrange.svg"
                  />
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
};

export default JournalOfWorldTrade;


// WEBPACK FOOTER //
// ./src/components/Journals/Subitems/Rankings/JournalOfWorldTrade.jsx